import React from "react";
import { DebounceInput } from "react-debounce-input";
import LabelComponent from "../../../LabelComponent";
import { labelSpacingPerView } from "./utils";

export default function EventDebounceInput({
  setSearchValue,
  className = "modal-search-bar mb-2 py-3",
}) {
  return (
    <>
    <LabelComponent className={labelSpacingPerView} title={"Search"} />
    <DebounceInput
      minLength={0}
      debounceTimeout={600}
      placeholder="Search for participants by name, company or title"
      onChange={(e) => {
        setSearchValue(e.target.value);
      }}
      className={className}
    />
    </>
  );
}
